module.exports = __webpack_public_path__ + "images/bannerPT-4ca72d198c7317abd73638ffcf8006b0.jpg";